var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "26",
        height: "23",
        viewBox: "0 0 26 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M22.0509 16.1608L20.2473 14.3587C21.1006 13.5642 21.7697 12.6244 22.2545 11.5393C22.7394 10.4541 22.9818 9.30118 22.9818 8.0804C22.9818 6.85962 22.7394 5.71635 22.2545 4.65059C21.7697 3.58483 21.1006 2.65471 20.2473 1.86024L22.0509 0C23.137 1.02701 24 2.2381 24.64 3.63327C25.28 5.02845 25.6 6.51083 25.6 8.0804C25.6 9.64998 25.28 11.1324 24.64 12.5275C24 13.9227 23.137 15.1338 22.0509 16.1608ZM18.3273 12.4403L16.4655 10.5801C16.8145 10.2507 17.0958 9.87766 17.3091 9.46105C17.5224 9.04443 17.6291 8.58422 17.6291 8.0804C17.6291 7.57659 17.5224 7.11637 17.3091 6.69976C17.0958 6.28314 16.8145 5.91013 16.4655 5.58071L18.3273 3.72047C18.9479 4.28242 19.4327 4.93641 19.7818 5.68244C20.1309 6.42847 20.3055 7.22779 20.3055 8.0804C20.3055 8.93301 20.1309 9.73233 19.7818 10.4784C19.4327 11.2244 18.9479 11.8784 18.3273 12.4403ZM9.30909 12.731C8.02909 12.731 6.93333 12.2756 6.02182 11.3649C5.1103 10.4541 4.65455 9.35932 4.65455 8.0804C4.65455 6.80149 5.1103 5.70666 6.02182 4.79592C6.93333 3.88518 8.02909 3.42981 9.30909 3.42981C10.5891 3.42981 11.6848 3.88518 12.5964 4.79592C13.5079 5.70666 13.9636 6.80149 13.9636 8.0804C13.9636 9.35932 13.5079 10.4541 12.5964 11.3649C11.6848 12.2756 10.5891 12.731 9.30909 12.731ZM0 22.0322V18.7768C0 18.1373 0.164849 17.5366 0.494546 16.9747C0.824242 16.4127 1.28 15.9864 1.86182 15.6957C2.85091 15.1919 3.96606 14.7656 5.20727 14.4168C6.44848 14.068 7.81576 13.8936 9.30909 13.8936C10.8024 13.8936 12.1697 14.068 13.4109 14.4168C14.6521 14.7656 15.7673 15.1919 16.7564 15.6957C17.3382 15.9864 17.7939 16.4127 18.1236 16.9747C18.4533 17.5366 18.6182 18.1373 18.6182 18.7768V22.0322H0Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }